import * as home from './home.types';
import { CUSTOM_LEAGUE_VIEW } from '../../app/views/Custom/module/custom';
import { ACCOUNT_INFORMATION_VIEW, CHANGE_PASSWORD_VIEW } from '../../app/views/AccountInfo/module/accountInfo';
import { HUDDLE_SEARCH_VIEW, PLAYER_LANDING_VIEW } from '../../app/views/HuddleSearch/module/huddleSearch';
import * as auth from './auth.types';
import { CHEAT_SHEETS_VIEW } from '../../app/views/CheatSheets/module/cheatSheets';
import { SEASON_STATS_VIEW } from '../../app/views/Season/module/seasonStats';
import { WEEKLY_STATS_VIEW } from '../../app/views/WeeklyStats/module/weeklyStats';
import { VIEW as EMAIL_PREFERENCES } from './emailSettings';
import { PROJECTIONS_VIEW } from '../../app/views/PlayerProjections/module/projections';
import { PREDICTIONS_VIEW } from '../../app/views/Predictions/module/predictions';
import { TEAM_POSITION_RANKINGS_VIEW } from '../../app/views/TeamPositionRankings/module/teamPositionRankings';
import { BOX_SCORES_VIEW } from '../../app/views/BoxScores/module/boxScores';
import { START_BENCH_VIEW } from '../../app/views/StartBench/module/startBench';
import { WAIVER_WIRE_VIEW } from '../../app/views/WaiverWire/module/waiverWire';
import { TEAMS_LANDING_VIEW } from '../../app/views/TeamsLanding/module/teamsLanding';
import { SUBSCRIBE_NEW_VIEW } from '../../app/views/Subscribe/module/subscribe';
import { SOS_VIEW } from '../../app/views/StrengthOfSchedule/module/strengthOfSchedule';
import { TEAM_PRM_VIEW } from '../../app/views/TeamPositionRanksMatchups/module/teamPRM';
import { PAYMENT_INFORMATION_VIEW, RENEW_SUBSCRIPTION_VIEW } from '../../app/views/PaymentInformation/module';
import { GAME_STATS_MATCHUPS_VIEW } from '../../app/views/GameStatsMatchups/module/gameStatsMatchups';
import * as todo from './aktaryTechPlaceholder.types';
import { VIEW as PLAYER_TRACKING } from './tracking.types';
import { PRINT_VIEW } from '../../app/views/Print/module/print';
import { PRINT_PROJECTIONS_VIEW } from '../../app/views/PrintProjections/module/printprojections';
import { NFL_SCHEDULE_GRID_VIEW } from '../../app/views/NFLSchedule/module/nflSchedule';

export const URL_OFF_SITE = 'url/NOT_HERE';

const NAV_KEY_MAP_TO_ACTIONS = {
  SIGN_OUT: auth.GO_LOGOUT,
  SEASON_TO_DATE: SEASON_STATS_VIEW,
  PRINT: PRINT_VIEW,
  PRINT_PROJECTIONS: PRINT_PROJECTIONS_VIEW,

  // My Huddle Menu
  CUSTOM_LEAGUES: CUSTOM_LEAGUE_VIEW,
  PLAYER_SEARCH: HUDDLE_SEARCH_VIEW,
  ACCOUNT_INFORMATON: ACCOUNT_INFORMATION_VIEW,
  CHANGE_PASSWORD: CHANGE_PASSWORD_VIEW,
  PAYMENT_INFORMATION: PAYMENT_INFORMATION_VIEW,
  EMAIL_PREFERENCES,
  PLAYER_TRACKING,

  // Draft Kit
  RANKINGS: PROJECTIONS_VIEW,
  PROJECTIONS: PROJECTIONS_VIEW,
  PREDICTIONS: PREDICTIONS_VIEW,
  CHEAT_SHEETS: CHEAT_SHEETS_VIEW,
  DRAFT_KIT: todo.GO_DRAFT_KIT,
  SLEEPERS: todo.GO_SLEEPERS,
  PLAYER_INJURY_REPORTS: todo.GO_PLAYER_INJURY_REPORTS,
  AVERAGE_DRAFT_POSITIONS: todo.GO_AVERAGE_DRAFT_POSITIONS,
  DRAFTING_STRATEGY: todo.GO_DRAFTING_STRATEGY,
  TOOLS: todo.GO_TOOLS,
  INDIVIDUAL_DEFENSIVE_PLAYERS: todo.GO_INDIVIDUAL_DEFENSIVE_PLAYERS,
  AUCTION_LEAGUES: todo.GO_AUCTION_LEAGUES,

  PLAYERS: PLAYER_LANDING_VIEW,
  TEAMS: TEAMS_LANDING_VIEW,
  IN_SEASON: todo.GO_IN_SEASON,
  START_BENCH_TOOL: START_BENCH_VIEW,
  WAIVER_WIRE: WAIVER_WIRE_VIEW,
  STATS: todo.GO_STATS,
  WEEKLY: WEEKLY_STATS_VIEW,
  BOX_SCORES: BOX_SCORES_VIEW,
  GAME_SCANS: BOX_SCORES_VIEW,
  TEAM_POSITION_RANKINGS: TEAM_POSITION_RANKINGS_VIEW,
  STRENGTH_OF_SCHEDULE: SOS_VIEW,
  TEAM_POSITION_RANK_MATCHUPS: TEAM_PRM_VIEW,
  GAME_STATISTICS_MATCHUPS: GAME_STATS_MATCHUPS_VIEW,
  TEAM_STATISTICS: todo.GO_TEAM_STATISTICS,

  // RESOURCES
  NFL_SCHEDULE_GRID: NFL_SCHEDULE_GRID_VIEW,
  RESOURCES: todo.GO_RESOURCES,
  DEPTH_CHARTS: todo.GO_DEPTH_CHARTS,
  NFL_SCHEDULE_WEEKLY_GRID: todo.GO_NFL_SCHEDULE_WEEKLY_GRID,
  NFL_FULL_WEEKLY_SCHEDULE: todo.GO_NFL_FULL_WEEKLY_SCHEDULE,
  NFL_DRAFT: todo.GO_NFL_DRAFT,
  NFL_CALENDAR: todo.GO_NFL_CALENDAR,
  NEWSLETTER_SIGNUP: todo.GO_NEWSLETTER_SIGNUP,

  // quicklinks
  PLAYER_RANKINGS: PROJECTIONS_VIEW,

  // Footer
  PRESEASON_DRAFT_KIT: home.GO_HOME,
  IN_SEASON_TOOLS: home.GO_HOME,
  DFS: home.GO_HOME,
  ARTICLES: URL_OFF_SITE,
  PLAYER_UPDATES: URL_OFF_SITE,
  STATISTICS: home.GO_HOME,
  NFL_DEPTH_CHARTS: home.GO_HOME,
  NFL_TEAMS: home.GO_HOME,
  NFL_PLAYERS: home.GO_HOME,
  FORUMS: URL_OFF_SITE,
  JOIN_THE_HUDDLE: SUBSCRIBE_NEW_VIEW,
  WHY_JOIN: URL_OFF_SITE,
  ABOUT_US: URL_OFF_SITE,
  FAQ: URL_OFF_SITE,
  FEEDBACK: URL_OFF_SITE,
  SITE_MAP: URL_OFF_SITE,
  HELP: URL_OFF_SITE,
  CONTACT_US: URL_OFF_SITE,
};

export default NAV_KEY_MAP_TO_ACTIONS;



// WEBPACK FOOTER //
// ./src/store/actions/navkey.types.js